import axios from "axios";
import axiosInstance from "./AxiosConfig";

export const fetchTokenApi = async () => axiosInstance.get("/parcours/siren/token");

export const fetchSirenDataApi = async (raisonSociale, accessToken) =>
  axios.get(`https://api.insee.fr/entreprises/sirene/V3.11/siret?q=denominationUniteLegale:"${raisonSociale}"~2`, {
    headers: { "Authorization": `Bearer ${accessToken}`, "Content-Type": "application/json" },
  });
